import { useState, useContext, useLayoutEffect, useEffect } from "react";
import { AlertContext } from '../contexts/AlertContext';
import { LoaderContext } from '../contexts/LoaderContext';

export const useSedes = (id = null) => {

    const [sede, setSede] = useState({});
    const [sedes, setSedes] = useState([]);
    const { alertRef } = useContext(AlertContext);
    const { setOpenLoader} = useContext(LoaderContext);

    useLayoutEffect(() => {
        let unsubscribed = true;
        unsubscribed && obtenerSedes();

        return () => unsubscribed = false;
    }, []);

    useEffect(() => {
        id && obtenerSede();
    }, [id]);

    const obtenerSede = async () => {
        setOpenLoader(true);
        const response = await fetch(`/api/sedes/${ id }`);
    
        if(!response?.ok) {
            setOpenLoader(false);
            alertRef?.current?.handleOpen('error', 'Error de conexión con el servidor.');
            return;
        }

        const { ok, message, data } = await response.json();

        if(!ok) {
            setOpenLoader(false);
            alertRef?.current?.handleOpen('error', message);
            return;
        }
        
        setSede(data);
        setOpenLoader(false);
    }

    const obtenerSedes = async () => {
        setOpenLoader(true);
        const response = await fetch(`/api/sedes`);
    
        if(!response?.ok) {
            setOpenLoader(false);
            alertRef?.current?.handleOpen('error', 'Error de conexión con el servidor.');
            return;
        }

        const { ok, message, data } = await response.json();

        if(!ok) {
            setOpenLoader(false);
            alertRef?.current?.handleOpen('error', message);
            return;
        }
        
        setSedes(data);
        setOpenLoader(false);
    }

    return {
        sede,
        sedes
    }
};